import { WifiOff } from "lucide-react";
import { useEffect, useState, type ReactNode } from "react";

export function OnlineOnlyBoundary({ children }: { children: ReactNode }) {
  const [online, setOnline] = useState(() => navigator.onLine);

  useEffect(() => {
    const update = () => setOnline(navigator.onLine);
    window.addEventListener("online", update);
    window.addEventListener("offline", update);
    return () => {
      window.removeEventListener("online", update);
      window.removeEventListener("offline", update);
    };
  }, []);

  return (
    <>
      <div aria-hidden={!online}>{children}</div>
      {!online && (
        <div
          className="fixed inset-0 z-[200] flex items-center justify-center bg-slate-950/65 p-5 backdrop-blur-sm"
          role="alertdialog"
          aria-modal="true"
          aria-labelledby="web-offline-title"
          aria-describedby="web-offline-description"
        >
          <section className="w-full max-w-md rounded-2xl bg-white p-7 text-center shadow-2xl">
            <WifiOff className="mx-auto h-11 w-11 text-amber-600" />
            <h1
              id="web-offline-title"
              className="mt-4 text-xl font-bold text-slate-900"
            >
              Web is online-only
            </h1>
            <p
              id="web-offline-description"
              className="mt-3 text-sm leading-6 text-slate-600"
            >
              The screen behind this message is read-only until the connection
              returns. MediCorePay Web does not save, calculate, or queue sales
              and stock changes offline. Use the authorized desktop app for a
              supported normal offline sale.
            </p>
            <button
              type="button"
              onClick={() => setOnline(navigator.onLine)}
              className="mt-6 rounded-lg bg-teal-700 px-5 py-2.5 text-sm font-semibold text-white"
            >
              Check connection
            </button>
          </section>
        </div>
      )}
    </>
  );
}
